import { render, staticRenderFns } from "./_TagData.vue?vue&type=template&id=76d6371e&scoped=true&"
import script from "./_TagData.vue?vue&type=script&lang=js&"
export * from "./_TagData.vue?vue&type=script&lang=js&"
import style0 from "./_TagData.vue?vue&type=style&index=0&id=76d6371e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d6371e",
  null
  
)

export default component.exports